import { historie } from '../history.js';
import { start } from '../core/start.js';
import { beads } from '../beads.js';
import { settings } from '../settings.js';
import { palette } from '../palette.js';
import { decompressFile } from './compress.js';
import { menu } from '../menu.js';
import { libraries } from '../libraries.js';
import { patterns } from '../patterns/patterns.js';

export const load = {};

load.project = ({fileObject, keepImage=false}) => {

    b3.store.mySet('openFile', fileObject);

    fileObject = decompressFile(fileObject);

    settings.currentProjectId = fileObject.id;

    const myConfig = {
        ...fileObject.settings,
        library: libraries[fileObject.settings.libraryIndex],
        pattern: patterns.arr.find(element => element.name === fileObject.settings.patternName),
        title: fileObject.title,
        description: fileObject.description,
        credits: fileObject.credits,
        instructions: fileObject.instructions,
        tags: fileObject.tags,
        camera: fileObject.camera,
        loading: true,
        renameColors: false,
        keepImage,
    };

    start.newProject(myConfig);

    // load palette

    fileObject.swatch.forEach(element => {
        if (!element) return;
        palette.addSwatch({
            fillColor: element.color,
            description: element.description,
            finishName: element.finishName,
            inner: element.inner || 'opaque',
            secondColor: element.secondColor || null,
            letterCode: element.letterCode || null,
            addHistory: false,
            id: element.id
        })
    });

    // next available id for adding new swatches

    palette.swatchIndex = 1 + Math.max(
        ...b3.store.state.swatches
            .filter(element => element.id)
            .map(element => element.id)
    );

    // now deal with beads

    const getImportedBead = bead => {
        if (settings.pattern.getImportedBead && beads.tempArray) {
            return settings.pattern.getImportedBead({bead});
        }
        return fileObject.beads.find(element =>
            element.row === bead.row &&
            element.column === bead.column
        );
    };

    beads.arr.forEach(bead => {
        const importedBead = getImportedBead(bead);
        if (typeof importedBead?.style === 'number') {
            importedBead.active = true;
            importedBead.selected = false;
            beads.assign(bead, importedBead, true);
        }
    });

    beads.tempArray = null;

    historie.updateRecentState();
    beads.unselectAll();

    palette.select(b3.store.state.swatches[0]);
    menu.returnToCanvas();
};